<div class="row d-flex flex-row justify-content-between align-items-center">
	<div class="col-3">
		<mat-form-field appearance="outline" class="w-100 headless-form-field">
			<mat-select [(value)]="actualSearchMode" (selectionChange)="changeSearchMode($event.value)">
				<mat-option [value]="mode.value" *ngFor="let mode of searchModes">
					{{ mode.viewValue | translate }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<div class="col-5">
		<mat-form-field
			[class.d-block]="
				actualSearchMode === 'address' || actualSearchMode === 'id_building' || actualSearchMode === 'town'
			"
			appearance="outline"
			class="w-100 headless-form-field d-none"
		>
			<!-- NAME is necessary to prevent input suggestions -->
			<input
				#searchTextField
				matInput
				[(ngModel)]="placeValue"
				name="inputName"
				type="text"
				placeholder="{{ placeholder }}"
				class="w-100"
			/>
		</mat-form-field>
		<form>
			<mat-form-field
				[class.d-block]="actualSearchMode === 'cluster'"
				appearance="outline"
				class="w-100 headless-form-field d-none"
			>
				<!-- NAME is necessary to prevent input suggestions  -->
				<input
					#searchTextFieldCluster
					matInput
					[formControl]="myControl"
					name="inputName"
					type="text"
					placeholder="{{ placeholder }}"
					[matAutocomplete]="auto"
					class="w-100"
				/>
				<mat-autocomplete #auto="matAutocomplete" (optionSelected)="clusterFunc($event.option)">
					<mat-option *ngFor="let option of clusterOptions | async" [value]="option">
						{{ option }}
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
		</form>
		<form>
			<mat-form-field
				[class.d-block]="actualSearchMode === 'pop'"
				class="w-100 headless-form-field d-none"
				appearance="outline"
			>
				<input
					#searchTextFieldPop
					type="text"
					placeholder="{{ placeholder }}"
					matInput
					[formControl]="popControl"
					name="inputName"
					[matAutocomplete]="autoPops"
					class="w-100"
				/>
				<mat-autocomplete #autoPops="matAutocomplete" (optionSelected)="emitPopOrPcn($event.option.value)">
					<mat-option *ngFor="let option of popPcnOptions | async" [value]="option">
						{{ option.alias ? option.alias : option.nome }}
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
		</form>
	</div>
	<div class="col-2">
		<button (click)="search()" class="headless-btn headless-btn--pink">
			<i class="fas fa-search mr-2"></i>
			<span>{{ "ACTIONS.SEARCH" | translate }}</span>
		</button>
	</div>
	<div class="col-2">
		<button (click)="reset(true)" class="headless-btn">
			<i class="fas fa-times mr-2"></i>
			<span>{{ "ACTIONS.RESET" | translate }}</span>
		</button>
	</div>
</div>
